// Generic one-shot scroll trigger: stamps `.nss-anim-in` on an element the
// first time it enters the viewport, then stops watching it. CSS owns the
// actual animation (see the .nss-timeline entrance sequence in nss-global).
// Opt in via the `.nss-timeline` utility or an `nss-scroll-anim` attribute.
const initScrollTriggers = () => {
  const els = document.querySelectorAll(`.nss-timeline, [nss-scroll-anim]`);
  if (!els.length || !(`IntersectionObserver` in window)) {
    els.forEach((el) => el.classList.add(`nss-anim-in`));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(`nss-anim-in`);
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.35 },
  );

  els.forEach((el) => io.observe(el));
};

if (document.readyState === `loading`) {
  document.addEventListener(`DOMContentLoaded`, initScrollTriggers);
} else {
  initScrollTriggers();
}
